const state = {
  corporations: {}
}

const getters = {

}

const actions = {
  requestCorporationList({commit}, payload){
    const api = this._vm.$apiEndpoints;

    return new Promise((resolve, reject) => {

      this._vm.$axios.get(api.corporationList()).then(function(response){
                  commit("_requestCorporationList", response.data)
                  resolve(response.data)
                }).catch(function(response){
                  reject(response)
                })
    })
  },
  requestCorporationCreate({commit}, payload){
    const api = this._vm.$apiEndpoints;

    return new Promise((resolve, reject) => {

      this._vm.$axios.post(api.corporationCreate(), payload).then(function(response){
                  resolve(response.data)
                }).catch(function(response){
                  reject(response)
                })
    })
  },
  requestCorporationDelete({commit}, payload){
    const api = this._vm.$apiEndpoints;

    return new Promise((resolve, reject) => {

      this._vm.$axios.delete(api.corporationDelete(payload)).then(function(response){
                  commit("_requestCorporationDelete", payload)
                  resolve(response.data)
                }).catch(function(response){
                  reject(response)
                })
    })
  },
  requestCorporationMoneyboxAssignmentCreate({commit}, payload){
    const api = this._vm.$apiEndpoints;
    const url = api.corporationMoneyboxAssignmentCreate(payload.corporation_id)
    var ax = this._vm.$axios;
    return new Promise((resolve, reject) => {
      
      var promises = []
      
      payload.selected_moneyboxes.forEach((item) =>{
        let prm = new Promise((resolve, reject) => {
          ax.post(url, {
              "moneybox_id": item.key
          }).finally(()=> {
            resolve()
          })
        })
        promises.push(prm)
      })

      Promise.all(promises).then(() => {
        resolve()
      })

    })
  },
  
}

const mutations = {
  _requestCorporationList(state, payload){
    state.corporations = payload
  },
  _requestCorporationDelete(state, payload){
    state.corporations.corporations.splice(state.corporations.corporations.findIndex(item=>item.id == payload), 1)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
